const AppLayer: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default AppLayer;
